//Adds a loader and disables a form button
interface SubmitButtonRecord {
	oldText: string;
	button: HTMLButtonElement;
}

const formButtons: SubmitButtonRecord[] = [];

function show(form: HTMLFormElement): void {
	const submitButton = $(form).find('button:not([type="button"])');

	const loaderSpan: HTMLSpanElement = document.createElement('span');
	loaderSpan.classList.add('spinner-grow');
	loaderSpan.classList.add('submit-loader');
	loaderSpan.classList.add('text-secondary');

	loaderSpan.setAttribute('role', 'status');
	loaderSpan.setAttribute('aria-hidden', 'true');

	submitButton.each((index, el: HTMLButtonElement) => {
		$(el).addClass('d-inline-flex justify-content-center align-items-center position-relative');

		const textSpan: HTMLSpanElement = document.createElement('span');
		textSpan.classList.add('submit-loader-original-text');
		textSpan.textContent = $(el).text();

		formButtons.push({ button: el, oldText: el.textContent });

		$(el).html(textSpan);
		$(el).append(loaderSpan);
		el.setAttribute('disabled', 'disabled');
	});
}

function resetAll(): void {
	formButtons.forEach((buttonRecord) => {
		buttonRecord.button.firstElementChild?.remove();
		buttonRecord.button.textContent = buttonRecord.oldText;
		buttonRecord.button.removeAttribute('disabled');
	});
}

export default { show, resetAll };
